import AuthService from "../../utilities/services/auth.service";

import { SeasonSummaryWrapper } from "../../components";

export default function SeasonSummaryPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <>
      <SeasonSummaryWrapper organization={organization} />
    </>
  );
}
